if (!customElements.get('gift-with-purchase')) {
  customElements.define(
    'gift-with-purchase',
    class GiftWithPurchase extends HTMLElement {
      constructor() {
        super();
        this.settings = null;
        this.validateGifts = this.validateGifts.bind(this);
      }
    
      connectedCallback() {
        this.settings = JSON.parse(this.dataset.settings);
        if (!this.settings.length) return;

        window.addEventListener('cart:dataChange', e => {
          this.validateGifts({ cart: e.detail });
        });
        

        window.addEventListener('productForm:add', e => {
          console.log(`productForm:add`)
          window.dispatchEvent(new CustomEvent('modal:closeById', { 
            detail: `gwp-selection`
          }));
        });
      }
      
      async getProductDetails(handle) {
        const productDetail = await fetch(`${window.Shopify.routes.root}products/${handle}.js`)
          .then(response => response.json())
          .then(gift => {
            if (!gift) return;
            return gift;
          })
          .catch((err) => {
            console.error(`Gift with Purchase: The free gift product is not available on your online store. Error: ${err}`);
            return false;
          });
        
        return productDetail;
      }
      
      addGift(gift) {
        this.getProductDetails(gift)
          .then(productDetail => {
            if (!productDetail?.variants[0]?.id || !productDetail?.variants[0]?.available) return;
            
            if (productDetail.variants.length > 1) {
              // this.renderSelectionModal(productDetail);
              // to revisit
              // lauren doesn't like my drawer-based select
            } else {
              fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                  id: productDetail.variants[0].id,
                  quantity: 1,
                  sections: ['inner-cart'],
                  properties: {
                    _free_gift: true,
                  },
                }),
              })
                .then(response => response.json())
                .then(data => {
                  window.dispatchEvent(new CustomEvent('productForm:add', { 
                    detail: data
                  }));
                })
                .catch(error => {
                  console.error('Error adding free gift to cart:', error);
                });
            }
          });
      }
      
      async removeGift(key) {
        try {
          const response = await fetch('/cart/change.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              id: key,
              quantity: 0,
              sections: ['inner-cart'],
            })
          });
          const cart = await response.json();
          window.dispatchEvent(new CustomEvent('productForm:add', {
            detail: cart
          }));
        } catch (error) {
          console.error('Error removing free gift from cart:', error);
        }
      }
      
      validateGifts({ cart }) {
        for (let i = 0; i < this.settings.length; i++) {
          const giftSettings = this.settings[i];
          const { gift_product, require_purchase_products, requirements_validation_type, requirements_products_list, require_purchase_threshold, price_threshold } = giftSettings;
      
          const cartSubtotal = cart.items_subtotal_price / 100; // Convert from cents to dollars
          const giftInCart = cart.items.find(item => 
            item.handle === gift_product && 
            item.properties && 
            item.properties._free_gift
          );
      
          let cartQualifies = true;
      
          if (require_purchase_threshold && cartSubtotal < price_threshold) {
            cartQualifies = false;
          }
      
          if (require_purchase_products) {
            const requiredProductIds = requirements_products_list.map(product => product.id);
            const cartProductIds = cart.items.map(item => item.product_id);
      
            if (requirements_validation_type === "all_products") {
              const allProductsInCart = requiredProductIds.every(id => cartProductIds.includes(id));
              if (!allProductsInCart) {
                cartQualifies = false;
              }
            }
      
            if (requirements_validation_type === "any_products") {
              const anyProductInCart = requiredProductIds.some(id => cartProductIds.includes(id));
              if (!anyProductInCart) {
                cartQualifies = false;
              }
            }
          }
                
          if (giftInCart && !cartQualifies) {
            // Cart does not qualify and gift is in cart, we should remove it.
            this.removeGift(giftInCart.key)
          } else if (!giftInCart && cartQualifies) {
            // Cart qualifies and gift is not in cart, we should attempt to add it.
            this.addGift(gift_product);
          } else if (giftInCart) {
            // Gift is in cart and the cart qualifies -- nothing needs to be done
          }
        }
      }
      
      // renderSelectionModal(product) {        
      //   this.innerHTML = `
      //     <template 
      //       data-mb="right"
      //       data-dt="right"
      //       style="
      //         height: 100%;
      //         --desktop-top: 20px; 
      //         --mobile-top: 20px;
      //       "
      //       data-modal-content="gwp-selection"
      //     >
      //       <div class="transform translate-x-4 border border-current lg:w-[665px] lg:max-h-[calc(100%-40px)] rounded-l-[22px] lg:rounded-3xl p-5 lg:py-10 lg:px-14 [&:has(.cart-item)_.empty-cart]:hidden [&:not(:has(.cart-item))_mini-cart]:hidden">
      //         <div class="sticky top-0 z-1 bg-primaryLight flex items-center gap-4 justify-between px-5 py-2.5">
      //           <strong>You got a free gift!</strong>
      //           <button 
      //             aria-label="Close selection modal"
      //             role="button" 
      //             data-modal-action="close"
      //             data-modal-id="gwp-selection" 
      //             class="block w-6 h-6 text-primaryDark ml-auto"
      //           >
      //             <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 11 10" fill="none">
      //               <path id="Vector 10" d="M1 0.5L5.5 5M5.5 5L1 9.5M5.5 5L10 9.5M5.5 5L10 0.5" stroke="currentColor"></path>
      //             </svg>
      //           </button>
      //         </div>
      //         <div class="p-5 max-md:w-[1920px]">
      //           <div class="grid grid-cols-1 gap-4 [&_[data-linked-product-selector]]:hidden">
      //             <intersection-loader 
      //               data-url="/products/${product.handle}"
      //               data-section-id="gwp-product-form"
      //             ></intersection-loader>
      //           </div>
      //         </div>
      //       </div>
      //     </template>
      //   `;
        
      //   window.dispatchEvent(new CustomEvent('modal:openById', { 
      //     detail: `gwp-selection`
      //   }));
      // }
    }
  );
}